module.exports = __webpack_public_path__ + "static/media/back.11657ef3.jpg";